module.exports = __webpack_public_path__ + "assets/img/btn-view-info-00c0bf7e.png";